import React, { useEffect, useState, useCallback } from "react";
import {
  Heart,
  ArrowLeft,
  Filter,
  Grid,
  List,
  MapPin,
  Cake,
  GraduationCap,
  Briefcase,
} from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { State, City } from "country-state-city";
import {
  // Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import Select from "react-select";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { Slider } from "./ui/slider";
import { Switch } from "./ui/switch";
import { Label } from "./ui/label";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { Header } from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { Horizontalslider } from "./horizontalslider.jsx";
import {
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import { setCurrentPage } from "../redux/navigationSlice.js";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { TrendingProfilesSlider } from "./Trending-profile-slider.jsx";
import { Footer } from "./Footer.jsx";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

import { ChevronDown, Calendar } from "lucide-react";
import { motion } from "framer-motion";
import { Popover, Box, Typography } from "@mui/material";

// Your icons
import TodayIcon from "@mui/icons-material/CalendarToday";
import WeekIcon from "@mui/icons-material/DateRange";
import { setProfileCount } from "../redux/profileCountSlice.js";

const BrowsePage = ({ onNavigate }) => {
  const [viewMode, setViewMode] = useState("grid");
  var layoutType = "vertical";
  const [allProfiles, setAllProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const completion = useSelector((state) => state.completion.value);
  const [openCompletionDialog, setOpenCompletionDialog] = useState(false);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [ShowSubscribeDialog, setShowSubscribeDialog] = useState(false);
  const [loadingAll, setLoadingAll] = useState(false);
  const [loadingFiltered, setLoadingFiltered] = useState(false);

  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const { t, i18n } = useTranslation();

  // FILTER STATES

  const [open, setOpen] = useState(false);

  const [filterAnchor, setFilterAnchor] = useState(null);

  const [period, setPeriod] = useState("all");

  // OPEN FILTER

  const handleFilterClick = (event) => {
    setFilterAnchor(event.currentTarget);

    setOpen(true);
  };

  // CLOSE FILTER

  const handleFilterClose = () => {
    setOpen(false);

    setFilterAnchor(null);
  };

  // HANDLE DATE FILTER CHANGE

  const handlePeriodChange = (value) => {
    setPeriod(value);
    // You can filter viewerProfiles here if needed
    handleFilterClose();
    console.log("Selected Period:", value);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sentInterestIds, setSentInterestIds] = useState([]);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  console.log(page, "PAGE", "COUNT", count);

  const [filters, setFilters] = useState({
    ageRange: [22, 35],
    location: "",
    religion: "",
    education: "",
    profession: "",
    onlineOnly: false,
    state: "",
    district: "",
  });

  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);

  useEffect(() => {
    const states = State.getStatesOfCountry("IN");
    setStatesList(states);
  }, []);

  const statesOptions = statesList.map((item) => ({
    value: item.name,
    label: item.name,
    isoCode: item.isoCode,
  }));

  const districtsOptions = districtList.map((d) => ({
    value: d,
    label: d,
  }));

  // On State Change
  // NOTE: state is stored directly on `filters.state` (not a separate piece
  // of state) so that fetchFilteredProfiles, which is memoized on `filters`,
  // always re-runs with the latest selected state instead of a stale value.
  const handleStateChange = (selectedOption) => {
    if (!selectedOption) {
      setDistrictList([]);
      setFilters((f) => ({ ...f, state: "", district: "" }));
      return;
    }

    setFilters((f) => ({ ...f, state: selectedOption.value, district: "" }));

    const stateObj = statesList.find(
      (item) => item.name === selectedOption.value
    );

    if (stateObj) {
      const cities = City.getCitiesOfState("IN", stateObj.isoCode);
      setDistrictList(cities.map((c) => c.name));
    } else {
      setDistrictList([]);
    }
  };

  const religionList = [
    "Hindu",
    "Christian",
    "Muslim",
    "Buddhist",
    "Jain",
    "Sikh",
    "No Religion Barrier",
  ];

  const educationList = [
    "No formal education",
    "Primary school",
    "High school / SSLC",
    "Higher secondary / HSC",
    "Diploma",
    "ITI / Vocational training",
    "Undergraduate (UG)",
    "Bachelor’s degree",
    "Postgraduate (PG)",
    "Master’s degree",
    "M.Phil",
    "Doctorate / Ph.D",
    "Professional degree (CA / CS / CFA / ICAI)",
    "Medical degree (MBBS / MD / MS)",
    "Engineering degree (BE / BTech / ME / MTech)",
    "Any degree",
    "Other",
  ];

  useEffect(() => {
    const fetchInterests = async () => {
      if (!token || !id) return;

      try {
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${id}`
        );

        const receivers = sentresponse?.data?.receivers || [];

        if (receivers.length > 0) {
          const receiverIds = receivers.map((r) => r.user_id);
          setSentInterestIds(receiverIds);
          console.log("Receiver IDs stored:", receiverIds);
        } else {
          setSentInterestIds([]);
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
        setSentInterestIds([]);
      }
    };
    fetchInterests();
  }, []);

  const fetchAllProfiles = useCallback(async () => {
    setLoading(true);
    try {
      let response;
      if (token && id) {
        response = await getWithTokenAPI(
          token,
          `/basic-profile/get_others?user_id=${id}&page=${count}&period=${period}`
        );
      } else {
        response = await getWithoutTokenAPI(
          `/basic-profile/get_all?page=${1}&limit=${10}`
        );
      }

      if (response?.statusCode === 200) {
        setAllProfiles(response?.data?.profiles || []);
        setPage(response?.data?.totalPages);
      }
    } catch (err) {
      console.error("Error fetching all profiles:", err);
    } finally {
      setLoading(false);
    }
  }, [token, id, count, period]);

  useEffect(() => {
    fetchAllProfiles();
  }, [fetchAllProfiles]);

  const fetchFilteredProfiles = useCallback(
    async (mode = "filter", searchValue = "", customFilters = filters) => {
      setLoading(true);
      try {
        let response;

        //       // --- SEARCH MODE ---
        if (mode === "search" && searchValue.trim() !== "") {
          if (token && id) {
            response = await getWithTokenAPI(
              token,
              `/basic-profile/get_all?search=${encodeURIComponent(searchValue)}`
            );
          } else {
            response = await getWithoutTokenAPI(
              `/basic-profile/get_all?search=${encodeURIComponent(searchValue)}`
            );
          }
        }

        //       // --- FILTER MODE ---
        else {
          setIsFilterApplied(true);
          const payload = {};

          if (customFilters.location) payload.city = customFilters.location;
          if (customFilters.profession)
            payload.profession = customFilters.profession;
          if (customFilters.religion) payload.religion = customFilters.religion;
          if (customFilters.education)
            payload.education = customFilters.education;
          if (customFilters.ageRange?.[0])
            payload.fromAge = customFilters.ageRange[0];
          if (customFilters.ageRange?.[1])
            payload.toAge = customFilters.ageRange[1];
          if (customFilters.state) payload.state = customFilters.state;
          if (customFilters.district) payload.district = customFilters.district;

          // Diagnostic only: lets us confirm exactly what the frontend sent
          // to /profile/filter when comparing against the backend response,
          // e.g. via the browser console, when result counts look wrong.
          console.log("[BrowsePage] /profile/filter request payload:", payload);

          if (token && id) {
            // ✅ Send payload as POST body
            response = await postWithTokenAPI(
              token,
              `/profile/filter?user_id=${id}`,
              payload
            );
          } else {
            setShowLoginDialog(true);
          }
        }

        if (response?.statusCode === 200) {
          setFilteredProfiles(response?.data?.profiles || []);
        } else {
          setFilteredProfiles([]);
        }
      } catch (error) {
        console.error("Error fetching filtered profiles:", error);
        setFilteredProfiles([]);
      } finally {
        setLoading(false);
      }
    },
    [token, id, filters]
  );

  const DEFAULT_FILTERS = {
    ageRange: [22, 35],
    location: "",
    religion: "",
    education: "",
    profession: "",
    onlineOnly: false,
    state: "",
    district: "",
  };

  // appliedFilters is a snapshot of `filters` taken only at the moment
  // "Apply Filters" (or a chip removal) actually runs the search. The
  // sidebar's `filters` state changes live as the user drags the age
  // slider / picks a dropdown, but that must NOT affect the results or the
  // "active filters" chips until the user explicitly applies — otherwise
  // touching an input makes the chips/results look out of sync with what
  // was actually searched for (e.g. dragging the age slider after Apply
  // shows a new "Age: x-y" chip while the results are still the old ones).
  const [appliedFilters, setAppliedFilters] = useState(null);

  // Resets every filter field and takes the user back to the default
  // "All Profiles" view. Shared by the sidebar's Clear Filters button and
  // the Clear Filters link shown above the filtered results.
  const handleClearFilters = () => {
    setFilters(DEFAULT_FILTERS);
    setAppliedFilters(null);
    setDistrictList([]);
    setIsFilterApplied(false);
    setFilteredProfiles([]);
  };

  const handleApplyFilters = () => {
    setAppliedFilters(filters);
    fetchFilteredProfiles("filter", "", filters);
  };

  // Human-readable summary of the filters that were actually applied, so the
  // results header shows *what was searched for* (each chip removable on
  // its own) instead of whatever the sidebar inputs currently show.
  const activeFilterChips = [];
  if (appliedFilters) {
    if (appliedFilters.religion)
      activeFilterChips.push({
        key: "religion",
        label: `${t("Religion")}: ${appliedFilters.religion}`,
      });
    if (appliedFilters.state)
      activeFilterChips.push({
        key: "state",
        label: `${t("State")}: ${appliedFilters.state}`,
      });
    if (appliedFilters.district)
      activeFilterChips.push({
        key: "district",
        label: `${t("District")}: ${appliedFilters.district}`,
      });
    if (appliedFilters.education)
      activeFilterChips.push({
        key: "education",
        label: `${t("Education")}: ${appliedFilters.education}`,
      });
    if (
      appliedFilters.ageRange?.[0] !== 22 ||
      appliedFilters.ageRange?.[1] !== 35
    )
      activeFilterChips.push({
        key: "ageRange",
        label: `${t("Age")}: ${appliedFilters.ageRange[0]}-${appliedFilters.ageRange[1]}`,
      });
  }

  const handleRemoveFilterChip = (key) => {
    const updatedFilters = { ...(appliedFilters || filters) };
    if (key === "religion") updatedFilters.religion = "";
    if (key === "education") updatedFilters.education = "";
    if (key === "ageRange") updatedFilters.ageRange = [22, 35];
    if (key === "state") {
      updatedFilters.state = "";
      updatedFilters.district = "";
      setDistrictList([]);
    }
    if (key === "district") updatedFilters.district = "";
    // Keep the sidebar inputs in sync with what's actually applied.
    setFilters(updatedFilters);
    setAppliedFilters(updatedFilters);
    fetchFilteredProfiles("filter", "", updatedFilters);
  };

  const handleProfileClick = async (profile) => {
    const progress = Math.round((completion / 4) * 100);
    if (!token) {
      setShowLoginDialog(true);
    }
    try {
      const profileId = profile?.basicProfile?.user_id || profile?.user_id;
      const profilename = profile?.basicProfile?.name || profile?.name;
      if (!profileId) {
        console.warn("No profile id found for", profile);
        return;
      }
      if (progress > 75) {
        const payload = { viewer_id: id, viewed_id: profileId };
        const response = await postWithTokenAPI(
          token,
          `/profile-view/track`,
          payload
        );
        if (response?.statusCode === 200) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          navigate(`/view-profile/${profilename}`, {
            state: { profileId: profileId },
          });
          dispatch(
            setProfileCount(response?.data?.unique_profiles_viewed_today)
          );
        } else if (response?.statusCode === 403) {
          setShowSubscribeDialog(true);
        } else {
          console.log(response);
        }
      } else {
        setOpenCompletionDialog(true);
      }
    } catch (error) {
      console.error("Error in viewed profile post", error);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchTerm.trim() === "") {
        setFilteredProfiles([]);
      } else {
        fetchFilteredProfiles("search", searchTerm);
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [searchTerm, fetchFilteredProfiles]);

  // useEffect(() => {
  //   const delay = setTimeout(() => {
  //     const activeFilter =
  //       filters.location ||
  //       filters.religion ||
  //       filters.education ||
  //       filters.profession ||
  //       filters.onlineOnly ||
  //       filters.ageRange[0] !== 22 ||
  //       filters.ageRange[1] !== 35;

  //     if (activeFilter) fetchFilteredProfiles("filter", "", filters);
  //     else setFilteredProfiles([]);
  //   }, 500);
  //   return () => clearTimeout(delay);
  // }, [filters, fetchFilteredProfiles]);

  useEffect(() => {
    if (!filteredProfiles.length) return;

    setFilteredProfiles((prevList) => {
      const updatedList = prevList.map((item) => {
        const userId = item?.user_id;
        const isInterested = sentInterestIds.includes(userId);
        return { ...item, interest: isInterested };
      });
      const isSame =
        JSON.stringify(prevList.map((i) => i.interest)) ===
        JSON.stringify(updatedList.map((i) => i.interest));

      return isSame ? prevList : updatedList;
    });
  }, [sentInterestIds, filteredProfiles]);

  useEffect(() => {
    if (!allProfiles.length) return;

    setAllProfiles((prevList) => {
      const updatedList = prevList.map((item) => {
        const userId = item?.user_id;
        const isInterested = sentInterestIds.includes(userId);
        return { ...item, interest: isInterested };
      });
      const isSame =
        JSON.stringify(prevList.map((i) => i.interest)) ===
        JSON.stringify(updatedList.map((i) => i.interest));

      return isSame ? prevList : updatedList;
    });
  }, [sentInterestIds, allProfiles]);

  const renderProfiles = (profiles) =>
    viewMode === "grid" ? (
      <div className="grid grid-cols-1 md:grid-cols-1 xl:grid-cols-1 gap-6 pb-6">
        <Horizontalslider
          profiles={profiles}
          layoutType="vertical"
          onNavigate={(profile) => {
            const id = profile?.basicProfile?.user_id || profile?.user_id;
            console.log("Clicked profile id:", id);
            handleProfileClick(profile);
          }}
        />
      </div>
    ) : (
      <div className="space-y-4">
        <Horizontalslider
          profiles={profiles}
          layoutType="vertical"
          onNavigate={(profile) => {
            const id = profile?.basicProfile?.user_id || profile?.user_id;
            console.log("Clicked profile id:", id);
            handleProfileClick(profile);
          }}
        />
      </div>
    );

  const [sortBy, setSortBy] = useState("relevance");

  const handleInterestToggle = async (profile) => {
    try {
      const payload = {
        from_user_id: id,
        to_user_id: profile?.user_id || profile?.basicProfile?.user_id,
      };

      const response = await postWithTokenAPI(
        token,
        `/interest/create`,
        payload
      );

      if (response?.statusCode === 200) {
        toast.success(`${t("Interest Sent Successfully")}`);
        window.location.reload();
        // setFilteredProfiles((prevProfiles) =>
        //   prevProfiles.map((p) =>
        //     (p.user_id || p?.basicProfile?.user_id) === payload.to_user_id
        //       ? { ...p, interest: true }
        //       : p
        //   )
        // );
        // setAllProfiles((prevProfiles) =>
        //   prevProfiles.map((p) =>
        //     (p.user_id || p?.basicProfile?.user_id) === payload.to_user_id
        //       ? { ...p, interest: true }
        //       : p
        //   )
        // );
      } else {
        toast.error(`${t("Failed to send interest ")}`);
      }
    } catch (error) {
      console.error("❌ Error sending interest:", error);
      toast.error(`${t("Something went wrong while sending interest!")}`);
    }
  };

  console.log(filteredProfiles, "filteredProfiles====");

  // ✅ UI
  return (
    <div className="min-h-screen bg-background">
      <Toaster position="top-right" />
      <Helmet>
        <title>Avan Aval - Browse</title>
        <meta name="description" content="This is my page description." />
        <meta name="keywords" content="React, Helmet, SEO" />
      </Helmet>

      <Header />
      {/* Top Bar */}
      <div style={{ width: "100%", display: "flex", marginTop: "2vh" }}>
        <input
          type="text"
          placeholder={t("Search profiles...")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border rounded-md p-2 text-sm w-80"
          style={{
            width: "47%",
            justifyContent: "center",
            // border: "1px solid grey",
            margin: "2vh auto",
          }}
        />
      </div>

      {/* Main Layout */}
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Filters */}
          <div className="lg:col-span-1 relative h-full">
            <div className="relative h-full">
              <Card
                className={`sticky top-24 ${
                  !token ? "opacity-40 blur-sm pointer-events-none" : ""
                }`}
              >
                <CardContent className="p-6 space-y-6">
                  <div className="flex items-center space-x-2 mb-2">
                    <Filter className="h-5 w-5" />
                    <h2 className="text-lg">{t("Filters")}</h2>
                  </div>

                  {/* Age Range */}
                  <div>
                    <Label className="text-sm mb-3 block">
                      {t("Age Range")}
                    </Label>
                    <Slider
                      value={filters.ageRange}
                      onValueChange={(value) =>
                        setFilters((f) => ({ ...f, ageRange: value }))
                      }
                      min={18}
                      max={50}
                      step={1}
                    />
                    <div className="flex justify-between text-xs mt-2 text-muted-foreground ">
                      <span>
                        {filters.ageRange[0]}
                        {t(" years")}
                      </span>
                      <span>
                        {filters.ageRange[1]} {t("years")}
                      </span>
                    </div>
                  </div>
                  <div>
                    <Label className="text-sm mb-3 block">
                      {t("Religion")}
                    </Label>
                    <Select
                      value={
                        filters.religion
                          ? {
                              value: filters.religion,
                              label: filters.religion,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setFilters((f) => ({
                          ...f,
                          religion: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      options={religionList.map((religion) => ({
                        value: religion,
                        label: religion,
                      }))}
                      placeholder={t("Select Religion")}
                      isClearable
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) =>
                          `text-sm border rounded-md bg-white ${
                            state.isFocused
                              ? "border-blue-500 ring-2 ring-blue-200"
                              : "border-gray-300"
                          }`,
                        option: (state) =>
                          `text-sm ${
                            state.isSelected
                              ? "bg-blue-500 text-white"
                              : state.isFocused
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900"
                          }`,
                        menu: () =>
                          "border border-gray-200 rounded-md shadow-lg",
                        placeholder: () => "text-gray-400 text-sm",
                        singleValue: () => "text-gray-900 text-sm",
                      }}
                    />
                  </div>

                  <div>
                    <label className="text-sm mb-3 block">{t("State")}</label>
                    <Select
                      value={
                        filters.state
                          ? { value: filters.state, label: filters.state }
                          : null
                      }
                      onChange={handleStateChange}
                      options={statesOptions}
                      placeholder={t("Select State")}
                      isClearable
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) =>
                          `text-sm border rounded-md bg-white ${
                            state.isFocused
                              ? "border-blue-500 ring-2 ring-blue-200"
                              : "border-gray-300"
                          }`,
                        option: (state) =>
                          `text-sm ${
                            state.isSelected
                              ? "bg-blue-500 text-white"
                              : state.isFocused
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900"
                          }`,
                        menu: () =>
                          "border border-gray-200 rounded-md shadow-lg",
                        placeholder: () => "text-gray-400 text-sm",
                        singleValue: () => "text-gray-900 text-sm",
                      }}
                    />
                  </div>

                  <div>
                    <label className="text-sm mb-3 block">
                      {t("District")}
                    </label>
                    <Select
                      value={
                        filters.district
                          ? { value: filters.district, label: filters.district }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setFilters((f) => ({
                          ...f,
                          district: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      options={districtsOptions}
                      placeholder={t("Select District")}
                      isClearable
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) =>
                          `text-sm border rounded-md bg-white ${
                            state.isFocused
                              ? "border-blue-500 ring-2 ring-blue-200"
                              : "border-gray-300"
                          }`,
                        option: (state) =>
                          `text-sm ${
                            state.isSelected
                              ? "bg-blue-500 text-white"
                              : state.isFocused
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900"
                          }`,
                        menu: () =>
                          "border border-gray-200 rounded-md shadow-lg",
                        placeholder: () => "text-gray-400 text-sm",
                        singleValue: () => "text-gray-900 text-sm",
                      }}
                    />
                  </div>

                  <div>
                    <Label className="text-sm mb-3 block">
                      {t("Education")}
                    </Label>

                    <Select
                      value={
                        filters.education
                          ? {
                              value: filters.education,
                              label: filters.education,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setFilters((f) => ({
                          ...f,
                          education: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      options={educationList.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                      placeholder={t("Select Education")}
                      isClearable
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) =>
                          `text-sm border rounded-md  bg-white ${
                            state.isFocused
                              ? "border-blue-500 ring-2 ring-blue-200"
                              : "border-gray-300"
                          }`,
                        option: (state) =>
                          `text-sm ${
                            state.isSelected
                              ? "bg-blue-500 text-white"
                              : state.isFocused
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900"
                          }`,
                        menu: () =>
                          "border border-gray-200 rounded-md shadow-lg",
                        placeholder: () => "text-gray-400 text-sm",
                        singleValue: () => "text-gray-900 text-sm",
                        clearIndicator: () =>
                          "text-gray-400 hover:text-gray-600",
                        dropdownIndicator: () =>
                          "text-gray-400 hover:text-gray-600",
                      }}
                    />
                  </div>

                  <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    {/* Clear Filters Button */}
                    <Button
                      variant="outline"
                      className="
      w-full 
      border border-gray-300 
      text-gray-700 
      py-2.5
      rounded-xl
      font-medium
      hover:bg-gray-100 
      hover:border-gray-400
      transition-all 
      cursor-pointer
    "
                      onClick={handleClearFilters}
                    >
                      {t("Clear Filters")}
                    </Button>

                    {/* Apply Filters Button */}
                    <Button
                      className="
      w-full 
      bg-gradient-to-r from-pink-500 to-rose-500 
      hover:from-pink-600 hover:to-rose-600 
      text-white 
      font-semibold
      py-2.5
      rounded-xl
      shadow-lg
      hover:shadow-xl
      transition-all
      cursor-pointer
      tracking-wide
    "
                      onClick={handleApplyFilters}
                    >
                      {t("Apply Filters")}
                    </Button>
                  </div>
                </CardContent>
              </Card>
              {!token && (
                <div
                  className="absolute inset-0 flex flex-col items-center justify-center rounded-xl z-50"
                  style={{
                    backgroundColor: "rgba(255, 251, 251, 0.5)", // White color with 50% opacity
                    backdropFilter: "blur(1px)", // Increased blur for better effect
                    border: "1px solid rgba(138, 133, 133, 0.7)",
                  }}
                >
                  <p className="text-black text-sm mb-3 font-medium">
                    {t("Please login to access filters")}
                  </p>

                  <Button
                    onClick={() => navigate("/login")}
                    className="w-[20px] bg-gradient-to-r from-pink-500 to-rose-500 
             hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                  >
                    Login
                  </Button>
                </div>
              )}
            </div>
          </div>

          <div className="lg:col-span-3 space-y-6">
            {(() => {
              const isSearching = searchTerm.trim() !== "";
              const isFilteredView = isSearching || isFilterApplied;

              return (
                <>
                  {/* Results header — exactly one title for whichever view is active,
                      kept inside one bordered block so it reads as a single unit
                      instead of the title and actions drifting apart. */}
                  <div className="bg-white  rounded-2xl p-5 space-y-4">
                    <div className="flex justify-between items-center flex-wrap gap-3">
                      <div>
                        <h2 className="text-2xl font-bold text-gray-900">
                          {isSearching
                            ? t("Search Results")
                            : isFilterApplied
                            ? t("Filtered Results")
                            : t("All Profiles")}
                        </h2>
                        {isFilteredView && !loading && (
                          <p className="text-sm text-muted-foreground mt-1">
                            {filteredProfiles.length} {t("profiles found")}
                          </p>
                        )}
                      </div>

                      {isFilterApplied ? (
                        <Button
                          type="button"
                          variant="outline"
                          onClick={handleClearFilters}
                          className="border-rose-300 text-rose-600 hover:bg-rose-50 hover:border-rose-400 rounded-xl font-semibold cursor-pointer"
                        >
                          {t("Clear Filters")}
                        </Button>
                      ) : (
                        token &&
                        !isSearching && (
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={handleFilterClick}
                            className="flex items-center gap-2 px-6 py-3 bg-rose-100 border border-rose-500 rounded-xl text-rose-600 font-semibold hover:shadow-lg transition-all cursor-pointer"
                          >
                            <Calendar size={18} />
                            <span>{t("Recently Joined")}</span>
                            <ChevronDown size={16} />
                          </motion.button>
                        )
                      )}
                    </div>

                    {/* Chips summarizing exactly which filters are active, each removable on its own */}
                    {isFilterApplied && activeFilterChips.length > 0 && (
                      <div className="flex flex-wrap gap-2 pt-3 border-t border-gray-100">
                        {activeFilterChips.map((chip) => (
                          <span
                            key={chip.key}
                            className="inline-flex items-center gap-1.5 p-3 rounded-full bg-rose-50 border border-rose-200 text-rose-700 text-xs font-medium"
                          > 
                            {chip.label}
                            {/* <button
                              type="button"
                              onClick={() => handleRemoveFilterChip(chip.key)}
                              className="cursor-pointer text-rose-400 hover:text-rose-600 leading-none text-sm"
                              aria-label={`${t("Remove")} ${chip.label}`}
                            >
                              ×
                            </button> */}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* "Recently Joined" period popover — only relevant to the default All Profiles view */}
                  <Popover
                    open={open}
                    anchorEl={filterAnchor}
                    onClose={handleFilterClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    sx={{
                      "& .MuiPopover-paper": {
                        borderRadius: "16px",
                        boxShadow: "0 20px 40px rgba(225, 29, 72, 0.15)",
                        border: "1px solid #fda4af",
                        marginTop: "8px",
                        minWidth: "220px",
                        overflow: "hidden",
                      },
                    }}
                  >
                    <Box sx={{ p: 3, backgroundColor: "#fff1f2" }}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: "#e11d48",
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 3,
                          fontSize: "14px",
                        }}
                      >
                        <Calendar size={16} />
                        {t("Select Period")}
                      </Typography>

                      {/* Options */}
                      <Box
                        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                      >
                        {[
                          {
                            value: "today",
                            label: t("Today"),
                            icon: <TodayIcon />,
                          },
                          {
                            value: "week",
                            label: t("This Week"),
                            icon: <WeekIcon />,
                          },
                          {
                            value: "month",
                            label: t("This Month"),
                            icon: <WeekIcon />,
                          },
                        ].map((option) => (
                          <motion.button
                            key={option.value}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={() => handlePeriodChange(option.value)}
                            className={`flex items-center gap-3 px-4 py-3 rounded-xl border font-semibold
            transition-all cursor-pointer
            ${
              period === option.value
                ? "text-white shadow-lg"
                : "bg-white text-gray-700 border-gray-200 hover:bg-rose-50 hover:text-rose-600"
            }`}
                            style={{
                              background:
                                period === option.value ? "#be123c" : "",
                              borderColor:
                                period === option.value ? "#9f1239" : "",
                            }}
                          >
                            <span>{option.icon}</span>
                            <span>{option.label}</span>
                          </motion.button>
                        ))}
                      </Box>

                      {/* Close Button */}
                      <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={handleFilterClose}
                        className="w-full mt-4 py-3 rounded-xl border border-gray-200 bg-white text-gray-600 font-medium hover:bg-gray-50 cursor-pointer"
                      >
                        {t("Close")}
                      </motion.button>
                    </Box>
                  </Popover>

                  {/* Exactly one results grid is ever visible at a time */}
                  {isFilteredView ? (
                    loading ? (
                      <p className="text-muted-foreground text-center py-12">
                        {t("Loading profiles...")}
                      </p>
                    ) : filteredProfiles && filteredProfiles.length > 0 ? (
                      renderProfiles(filteredProfiles)
                    ) : (
                      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
                        <div className="w-20 h-20 bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl flex items-center justify-center mb-6">
                          <svg
                            className="w-10 h-10 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={1.5}
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                          </svg>
                        </div>

                        <h3 className="text-2xl font-bold text-gray-900 mb-3 tracking-tight">
                          {t("No profiles found")}
                        </h3>

                        <p className="text-gray-500 max-w-md text-base leading-relaxed mb-6">
                          {t(
                            "Try adjusting your search criteria or filters to find profiles that match your needs."
                          )}
                        </p>

                        {isFilterApplied && (
                          <Button
                            onClick={handleClearFilters}
                            className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                          >
                            {t("Clear Filters")}
                          </Button>
                        )}
                      </div>
                    )
                  ) : (
                    <>
                      {loading && allProfiles.length === 0 ? (
                        <p className="text-center py-8 text-muted-foreground">
                          {t("Loading profiles...")}
                        </p>
                      ) : allProfiles.length > 0 ? (
                        renderProfiles(allProfiles)
                      ) : (
                        <p className="text-center py-8 text-muted-foreground">
                          {t("No profiles available for the selected filter")}
                        </p>
                      )}

                      {count !== page && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "2vh",
                          }}
                        >
                          <Button
                            className="w-full bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                            onClick={
                              token
                                ? () => setCount((count) => count + 1)
                                : () => setShowLoginDialog(true)
                            }
                            style={{
                              width: "auto",
                              height: "auto",
                              paddingTop: "9px",
                            }}
                          >
                            {t("View More")}
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                </>
              );
            })()}
          </div>
        </div>
      </div>
      <Footer />

      <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("You’re Almost There!")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("Log in to explore profiles and start connecting")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowLoginDialog(false)}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setShowLoginDialog(false);
                navigate("/login"); // 👈 navigate to login screen
              }}
            >
              {t("Login")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog
        open={ShowSubscribeDialog}
        onOpenChange={setShowSubscribeDialog}
      >
        <AlertDialogContent className="max-w-sm text-center">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600 text-xl font-semibold">
              🔔 {t("Subscription Required")}
            </AlertDialogTitle>
            <AlertDialogDescription className="text-gray-600 mt-2">
              {t("Upgrade your plan to explore more matches")}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="flex justify-center gap-3 mt-4">
            <AlertDialogCancel
              onClick={() => setShowSubscribeDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setShowSubscribeDialog(false);
                navigate("/subscription");
                // dispatch(setCurrentPage("subscription"));
              }}
            >
              {t("Subscribe Now")}
            </AlertDialogAction>
          </div>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog
        open={openCompletionDialog}
        onOpenChange={setOpenCompletionDialog}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Your Journey Starts Here")}</AlertDialogTitle>

            <AlertDialogDescription>
              {t(
                "Complete your profile to unlock full access and explore profiles"
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setOpenCompletionDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setOpenCompletionDialog(false);
                navigate("/profile");
                dispatch(setCurrentPage("profile"));
              }}
            >
              {t("Continue")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default BrowsePage;
